export default {
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  days: {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
  },
  labels: {
    month: 'Month',
    year: 'Year',
    dayOfWeek: 'Day of the week',
    set: 'Set',
    format: 'dd.mm.yyyy',
    formatWithTime: 'dd.mm.yyyy hh:mm'
  },
}